import type { SectionId } from '../types';
import { WORKFLOW_SCORE } from '../editorial/workflowScore';
import { NARRATIVE,CLOSER_DURATION } from '../narrative/sequence';
import { SHARE_SEQUENCE } from '../proofs/share/sequence';

export interface Chapter { id: SectionId|'film'|'intro'; duration:number; autoNext?:boolean; cue?:string; transitionMs?:number; departureHold?:number }
/** Seconds are authored viewing time, independent of document length and input speed. */
export const CHAPTERS:readonly Chapter[]=[
 {id:'film',duration:62985.63694649171,autoNext:true},{id:'intro',duration:6200},
 {id:'workflow',duration:WORKFLOW_SCORE.duration,transitionMs:3600,departureHold:.45},{id:'uses-game',duration:10700},
 {id:'uses-site',duration:40500},{id:'uses-video',duration:NARRATIVE.contentEnd+4000,transitionMs:3600,departureHold:.4},
 {id:'uses-freelance',duration:24600},{id:'uses-more',duration:33000},
 {id:'share',duration:SHARE_SEQUENCE.complete,transitionMs:5600,departureHold:.6},{id:'audience',duration:10500,transitionMs:12500,departureHold:.76},
 {id:'closer',duration:CLOSER_DURATION,autoNext:true},{id:'pricing',duration:12500,cue:'Скачай Blender Bridge'},
 {id:'install',duration:10000},{id:'footer',duration:8000},
];
export interface CinemaState { phase:'hero'|'playing'|'ready'|'transition'|'ended';chapter:number;elapsed:number;transition:number;destination:number;paused:boolean;visit:number;clock:number }
export const TRANSITION_MS=3000;
export class CinemaTransport {
 readonly completed=new Set<number>();
 readonly state:CinemaState={phase:'hero',chapter:0,elapsed:0,transition:0,destination:0,paused:false,visit:0,clock:0};
 start(){this.state.chapter=0;this.state.elapsed=0;this.state.phase='playing';this.state.paused=false;this.state.visit++;}
 pause(){this.state.paused=true;}
 resume(){this.state.paused=false;}
 request(direction:1|-1){
  const s=this.state;if(s.paused||!['ready','ended'].includes(s.phase))return;
  const next=Math.max(1,Math.min(CHAPTERS.length-1,s.chapter+direction));
  if(next===s.chapter)return;s.destination=next;s.transition=0;s.phase='transition';
 }
 tick(delta:number,hidden=false,actorsComplete=true,departureComplete=true){
  const s=this.state;if(hidden||s.paused||s.phase==='hero')return;
  // This is an audiovisual clock, not a physics integration step.
  const dt=Math.max(0,Number.isFinite(delta)?delta:0);
  s.clock+=dt;
  if(s.phase==='transition'){
   const duration=CHAPTERS[s.chapter]!.transitionMs??TRANSITION_MS;
   const limit=departureComplete?duration:duration*(CHAPTERS[s.chapter]!.departureHold??.12);
   s.transition=Math.min(limit,s.transition+dt);
   if(s.transition===duration){s.chapter=s.destination;s.elapsed=0;s.phase='playing';s.visit++;}
  }else if(s.phase==='playing'){
   s.elapsed=Math.min(CHAPTERS[s.chapter]!.duration,s.elapsed+dt);
   if(s.elapsed===CHAPTERS[s.chapter]!.duration&&actorsComplete){
    this.completed.add(s.chapter);
    if(CHAPTERS[s.chapter]!.autoNext){
     if(CHAPTERS[s.chapter]!.id==='closer'){s.destination=s.chapter+1;s.transition=0;s.phase='transition';}
     else{s.chapter++;s.elapsed=0;s.visit++;}
    }
    else s.phase=s.chapter===CHAPTERS.length-1?'ended':'ready';
   }
  }
 }
}
